import type { CSSProperties } from 'react';
import { cx } from '../cx';

/**
 * Ícones ilustrados (vidro e traço), um arquivo por ícone em `assets/glyphs/<nome>.png` (384 px, fundo transparente).
 * São marca de página e de estado vazio: de 40 px para cima. Ícone pequeno de interface continua sendo o `Icon` (traço).
 * Gerados por `apps/worker/src/generate-icons.ts` e igualados em tamanho por `scripts/build-glyphs.py`.
 * Novo ícone = novo conceito na lista do gerador + o nome aqui.
 */
export const GLYPHS = [
  'home', 'ver', 'evidencias', 'sinais', 'contradicoes', 'hipoteses', 'decisoes', 'solucoes',
  'iniciativas', 'efeito', 'aprendizado', 'memoria', 'projetos', 'clientes', 'sessoes', 'agenda',
  'busca', 'radar', 'live', 'campo', 'o-raro', 'perfil', 'notificacoes', 'configuracoes',
  'microfone', 'audio', 'video', 'fotos', 'documentos', 'pdf', 'png', 'doc',
  'links', 'web', 'fontes', 'tags', 'pastas', 'importar', 'exportar', 'mais',
  'machine', 'parede', 'observacoes', 'perguntas', 'pecas', 'sala',
] as const;
export type GlyphName = (typeof GLYPHS)[number];

const urlOf = (name: GlyphName) => new URL(`../assets/glyphs/${name}.png`, import.meta.url).href;

export function Glyph({ name, size = 48, className, style }: { name: GlyphName; size?: number; className?: string; style?: CSSProperties }) {
  return <img aria-hidden alt="" draggable={false} src={urlOf(name)} width={size} height={size} className={cx('rr-glyph', className)} style={style} />;
}

/** Ícone de uma fonte pelo tipo e, em documento, pela extensão do título. */
export function sourceGlyph(type: string, title = ''): GlyphName {
  if (type === 'document') return /\.pdf$/i.test(title) ? 'pdf' : /\.docx?$/i.test(title) ? 'doc' : 'documentos';
  const map: Record<string, GlyphName> = { image: 'png', video: 'video', audio: 'audio', interview: 'sessoes', meeting: 'clientes', url: 'links', spreadsheet: 'iniciativas', analytics: 'live', social: 'web', research: 'busca', crm: 'memoria', review: 'o-raro', field_note: 'tags' };
  return map[type] ?? 'documentos';
}
